<template>
  <div class="flex flex-col md:flex-row border-b-[1px] border-solid border-[#4c5658] text-[15px] text-[#828585] min-h-[60px] md:items-center py-4 md:py-0 gap-2">
    <div class="md:flex-1">
      Delete your Arcweave account
    </div>
    <button type="button" @click="deleteAccount" class="text-accent-400 cursor-pointer p-4 pr-0 ml-auto">
      Delete account
    </button>
  </div>
  <delete-account-modal
    v-if="open"
    @closeModal="open = false"
  />
</template>

<script>
import { ref } from 'vue';
import DeleteAccountModal from './DeleteAccountModal.vue';

export default {
  components: {
    DeleteAccountModal,
  },

  setup() {
    const open = ref(false);

    return {
      open,
    };
  },

  methods: {
    deleteAccount() {
      this.open = true;
    }
  }
};
</script>